<template>
	<div style="width:90%">

		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="名词名称:" class='tiny'>
						<el-input v-model="title" placeholder="请输入名词名称" />
					</el-form-item>
					<el-form-item class='tiny'>
						<el-button type="primary" @click="search">搜索</el-button>
						<el-button @click="empty">清空</el-button>
					</el-form-item>
					<el-form-item class='tiny'>
						<el-button type="primary" @click="editialogVisible('')">
							新增
						</el-button>
					</el-form-item>

				</el-form>
			</header>
		</div>

		<el-table :data="messageList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="name" label="名词名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			
			<el-table-column prop="desc" label="内容" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button  size="small" type="text"
						@click="showContent(scope.row.desc)">查看</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="readTimes" label="阅读量" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="orderIndex" label="排序" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="content" label="是否启用" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					{{scope.row.isEnable?'是':'否'}}
				</template>
			</el-table-column>
			<el-table-column prop="createDate" width="200%" label="创建时间" align="center">
			</el-table-column>
			<!-- <el-table-column prop="status" label="状态" align="center">
				<template slot-scope="scope">
					<p v-if="!scope.row.status">系统新闻</p>
					<p v-if="scope.row.status == 'unread'">未读</p>
					<p v-if="scope.row.status == 'read'">已读</p>
				</template>
			</el-table-column> -->
			<el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					<!--<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">拨币</el-button> -->
					<el-dropdown v-if="scope.row.userId == 0" trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="readingecordCli(scope.row.id)">阅读记录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>
			</el-table-column>

		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="messageList.pageNum" @current-change="pageChange"
			layout="total, sizes, prev, pager, next, jumper" :total="messageList.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 查看 -->
		<el-dialog title="提示" :visible.sync="showContentDialog" width="50%">
			<span v-html="contentValue"></span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 阅读记录 -->
		<el-dialog title="阅读记录" :visible.sync="readingecord" width="50%" :close-on-click-modal="false">
			<el-table :data="MessageReadingRecordList.list" stripe style="width: 100%;" :header-cell-style="headClass"
				v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
				<!-- <el-table-column prop="id" label="序号" sortable align="center">
			    </el-table-column> -->
				<el-table-column prop="userId" label="用户id" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="username" label="用户登录名" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="createDate" label="阅读时间" align="center" :show-overflow-tooltip="true">
				</el-table-column>
			</el-table>

			<el-pagination style="margin: 20px;" background :current-page="MessageReadingRecordList.pageNum"
				@current-change="pageChangeReadingRecord" layout="total, sizes, prev, pager, next, jumper"
				:total="MessageReadingRecordList.total" @size-change="handleSizeChangeReadingRecord">
			</el-pagination>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="readingecord = false">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 编辑 -->
		<el-dialog style="float:rigin" :title="popupTitle" :visible.sync="editDialogVisible" width="50%" :close-on-click-modal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">
					<el-form-item :label-width="formLabelWidth" label="名词名称:">
						<el-col :span="20">
							<el-input v-model="form.name" placeholder="请输入名词名称" />
						</el-col>
					</el-form-item>


				

					<!-- <el-form-item :label-width="formLabelWidth" label="用户名:">
						<el-col :span="8">
							<el-input v-model="form.username" placeholder="请输入用户名" />
						</el-col>
						<div style="width: 50px;display: inline-block;"></div>
						<el-button type="primary" @click="searchUserName">搜索</el-button>
						<el-button type="primary" @click="emptyUserName">清空</el-button>
					</el-form-item> -->

					<el-form-item :label-width="formLabelWidth" label="排序级别">
						<el-input type="text" oninput="value=value.replace(/[^0-9]/g,'')" style="width: 150px;"
							v-model="form.orderIndex" placeholder="请输入数字(降序)" />
					</el-form-item>
					<el-form-item :label-width="formLabelWidth" label="是否启用">
						<el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false" >
						</el-switch>
					</el-form-item>
					

					

					<el-form-item  label="内容" prop="words">
						<div id="lpc-quill" class="quill">
							<el-upload v-show="false" ref="upload" class="upload-demo" :action="httpUrl" :before-upload="beforeUpload"
								:on-success="upScuccess" :on-error="uploadError" />
							<quill-editor v-model="form.desc" ref="myQuillEditor" class="editer" :options="editorOption"
								@ready="onEditorReady($event)">
							</quill-editor>
						</div>
					</el-form-item>
					

					<el-form-item>
						<el-button :loading="toEditLoading" type="primary" @click="toEdit()">提交</el-button>
						<el-button @click="editDialogVisible = false">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('system');
	import {
		quillEditor
	} from 'vue-quill-editor' //调用编辑器
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				popupTitle:'新增',
				toEditLoading:false,
				title: '',
				systemMessage: null,
				loading: false,
				messageList: [], //新闻
				userList: [],
				MessageReadingRecordList: [], //阅读记录
				dialogVisible: false,
				editDialogVisible: false,
				readingecord: false,
				form: {
					id: 0,
					title: "",
					titleEn: "",
					userId: 0,
					username: '',
					typeId: 0,
					action: "",
					status: "",
					content: "",
					contentEn: ""
				},
				mainFormRules: {
					title: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
				},
				integralList: [],
				integralId: "", //积分id
				appropriation: "",
				ids: '', //授权用户id
				userData: [{}], //用户角色列表
				userDataList: [], //用户角色列表选中的
				formLabelWidth: "200px",
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {},
				index: null,
				contentValue: "",
				showContentDialog: false,
				httpUrl: urls,
				editorOption: { // 富文本编辑器配置
					placeholder: '请输入内容',
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
								[{
									'header': 1
								}, {
									'header': 2
								}], // 标题，键值对的形式；1、2表示字体大小
								[{
									'list': 'ordered'
								}, {
									'list': 'bullet'
								}], // 列表
								[{
									'script': 'sub'
								}, {
									'script': 'super'
								}], // 上下标
								[{
									'indent': '-1'
								}, {
									'indent': '+1'
								}], // 缩进
								[{
									'direction': 'rtl'
								}], // 文本方向
								[{
									'size': ['small', false, 'large', 'huge']
								}], // 字体大小
								[{
									'color': []
								}, {
									'background': []
								}], // 字体颜色，字体背景颜色
								[{
									'align': []
								}], // 对齐方式
								['clean'], // 清除字体样式
								['image'] // 上传图片、上传视频
							],
							handlers: {
								'image': function (value) {
									if (value) {
										document.querySelector('#lpc-quill .upload-demo input').click()
									} else {
										this.quill.format('image', false)
									}
								}
							}
						}
					},
					theme: 'snow'
				},
				editorOptionen: { // 富文本编辑器配置
					placeholder: '请输入英文内容',
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
								[{
									'header': 1
								}, {
									'header': 2
								}], // 标题，键值对的形式；1、2表示字体大小
								[{
									'list': 'ordered'
								}, {
									'list': 'bullet'
								}], // 列表
								[{
									'script': 'sub'
								}, {
									'script': 'super'
								}], // 上下标
								[{
									'indent': '-1'
								}, {
									'indent': '+1'
								}], // 缩进
								[{
									'direction': 'rtl'
								}], // 文本方向
								[{
									'size': ['small', false, 'large', 'huge']
								}], // 字体大小
								[{
									'color': []
								}, {
									'background': []
								}], // 字体颜色，字体背景颜色
								[{
									'align': []
								}], // 对齐方式
								['clean'], // 清除字体样式
								['image'] // 上传图片、上传视频
							],
							handlers: {
								'image': function (value) {
									if (value) {
										document.querySelector('#lpc-quill-en .upload-demo input').click()
									} else {
										this.quill.format('image', false)
									}
								}
							}
						}
					},
					theme: 'snow'
				}

			};
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		methods: {
			remoteMethod(query) {
				if (query.length >= 2) {
					this.loading = true;
					setTimeout(() => {
						let webData = {
							pageNum: 1,
							pageSize: 30,
							username: query
						}
						this.$api.getUserList(this.$encrypt(webData)).then((res) => { //角色管理列表
							res=JSON.parse(this.$decrypt(res.data))
							if (res.state == 'success') {
								this.userList = res.data.list
							}
							this.loading = false
						})
						this.loading = false;
					}, 200);
				} else {
					this.options = [];
				}
			},
			empty() {
				this.title = '';
			},
			search() {
				this.loading = true;
				this.page.title = this.title ? this.title : null;
				let webData = {
					pageNum: 1,
					pageSize: this.page.pageSize,
					name: this.title ? this.title : null
				}
				this.$api.definition(webData).then((res) => { //角色管理列表
					if (res.state == 'success') {
						this.messageList = res.data
					}
					this.loading = false
				})
			},
			emptyUserName() {
				this.form.username = '';
			},
			
			showContent(content) {
				this.contentValue = content
				this.showContentDialog = true
			},
			//阅读记录弹框
			readingecordCli(msgid) {
				this.readingecord = true;
				this.getMessageReadingRecordList(msgid);
			},
			//编辑弹框
			editialogVisible(id) {
				if (id) {
					//编辑查询
					this.popupTitle = '编辑'
					this.ids = id
					this.form.timer = []
					this.$api.findByIddefinition(id).then((res) => { //通过id查询新闻
						console.log(res);
						if (res.state == 'success') {
							this.form = res.data;
							
						}
					})
				} else {
					this.popupTitle = '新增'
					this.ids = ""
					this.form = {}
				}
				this.editDialogVisible = true;
			},
			toEdit() {
				this.toEditLoading = true;
				if (this.ids) {
					//编辑
					let data = this.form;
					this.$api.updateiDefinition(data).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.getMessageList();
						} else {
							this.$message.error(res.message);
						}
						this.toEditLoading = false;
					})
				} else {
					//添加
					let data = {
						name: this.form.name,
						desc: this.form.desc,
						isEnable: this.form.isEnable,
						
						orderIndex: this.form.orderIndex,
					
					}
					// console.log('传递参数--',data);
					this.$api.addDefinition(data).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.getMessageList();
						} else {
							this.$message.error(res.message);
						}
						this.toEditLoading = false;
					})
				}
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartStartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.startDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.endDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			//新闻
			pageChange(data) {
				this.page.pageNum = data
				this.getMessageList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getMessageList()
			},
			getMessageList() {
				this.loading = true
				let data = this.page;
				this.$api.definition(data).then((res) => { //新闻
					console.log('表格数据--',res);
					if (res.state == 'success') {
						this.messageList = res.data
						this.loading = false
					}
				})
			},
		
			//阅读记录
			pageChangeReadingRecord(data) {
				this.page.pageNum = data
				this.getMessageReadingRecordList()
			},
			handleSizeChangeReadingRecord(val) {
				this.page.pageSize = val
				this.getMessageReadingRecordList()
			},
			getMessageReadingRecordList(msgId) {
				this.loading = true
				if (msgId) {
					this.page.msgId = msgId;
				}
				let data = this.page
				this.$api.queryMessageUserRead(data).then((res) => { //阅读记录
					console.log(res);
					if (res.state == 'success') {
						this.MessageReadingRecordList = res.data
						this.loading = false
					}
				})
			},
			//删除
			toDelete(id) {
				this.$confirm('此操作将永久删除该名词, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.deliDefinition(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getMessageList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			beforeUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			upScuccess(res, file) {
				console.log(res)
				const quill = this.$refs.myQuillEditor.quill
				if (res.state === 'success' && res.data !== null) {
					const length = quill.getSelection().index // 获取光标所在位置
					quill.insertEmbed(length, 'image', res.message) // 插入图片
					quill.setSelection(length + 1) // 调整光标位置到最后
				} else {
					this.$message.error('图片上传失败')
				}
				console.log(quill,132)
			},
			uploadError() {
				this.$message.error('图片上传失败')
			},
			onEditorReady(editor) { // 准备编辑器
				console.log(editor)
			},
			beforeUploaden(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			upScuccessen(res, file) {
				const quill = this.$refs.myQuillEditoren.quill
				if (res.state === 'success' && res.data !== null) {
					const length = quill.getSelection().index // 获取光标所在位置
					quill.insertEmbed(length, 'image', res.data) // 插入图片
					quill.setSelection(length + 1) // 调整光标位置到最后
				} else {
					this.$message.error('图片上传失败')
				}
			},
			uploadErroren() {
				this.$message.error('图片上传失败')
			},
			onEditorReadyen(editor) { // 准备编辑器
				console.log(editor)
			},
		},
		created() {
			this.getMessageList();
		},
		mounted: function () { },
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}
</style>